import React from "react";
import {
  Create,
  SimpleForm,
  FileField,
  Toolbar,
  FileInput,
  ListButton,
  SaveButton,
} from "react-admin";
import { onAddPurchaseMarketingUploadCreateValidationCreate } from "../../Service/Validation/AddBonusValidation";
import { BuymoteOrderIDTypeSelectInput } from '../../UI/Input/SelectInput'
import Grid from "@material-ui/core/Grid";

const PageTitle = () => {
  return <span>Add Bonus</span>;
};

const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="show" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);
const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};

const AddBuymoteEduquestCertificateIDUploadCreate = (props) => {

  return (
    <Create title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm toolbar={<FormToolbar />} reValidateMode="onBlur" warnWhenUnsavedChanges validate={onAddPurchaseMarketingUploadCreateValidationCreate}>
        <SanitizedGrid container spacing={3} fullWidth>
          <FileInput source="attachments">
            <FileField source="src" title="title" />
          </FileInput>
          <BuymoteOrderIDTypeSelectInput label="Type" source="orderID_type" />

        </SanitizedGrid>

      </SimpleForm>
    </Create>
  );
};
export default AddBuymoteEduquestCertificateIDUploadCreate;
